
import {Component, OnInit} from '@angular/core';
import {UIRouter} from '@uirouter/angular';
import {UserService} from './user.service';
import {User} from './user.model';
import {TranslateService} from '@ngx-translate/core';
import {EnumerationInterface} from '../enumeration/enumeration.interface';
import {EnumerationService} from '../enumeration/enumeration.service';

enum FormMode {
  ADD = 1,
  UPDATE = 2
}

@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html'
})
export class UserFormComponent implements OnInit {

  public formMode: FormMode;
  public blockTitle: string;
  public user: User = new User();
  public userRoles: EnumerationInterface;

  constructor(
    protected router: UIRouter,
    protected userService: UserService,
    protected enumerationService: EnumerationService,
    protected translate: TranslateService
  ) {
    this.enumerationService.get('user-role').subscribe((userRoles: EnumerationInterface) => {
      this.userRoles = userRoles;
    });
  }

  public ngOnInit(): void {

    if(this.router.stateService.params && this.router.stateService.params.id) {
      this.formMode = FormMode.UPDATE;
      this.blockTitle  = this.translate.instant('user.form.update.blockTitle');
      this.userService.get(this.router.stateService.params.id).subscribe((user) => {
        this.user = <User>user;
      });
    } else {
      this.formMode = FormMode.ADD;
      this.blockTitle  = this.translate.instant('user.form.add.blockTitle');
    }
  }

  public toggleRole(role, event) {
    if((event.target.checked === true) && (this.user.roles.indexOf(role) === -1)) {
      this.user.roles.push(role);
    }

    if((event.target.checked === false) && (this.user.roles.indexOf(role) !== -1)) {
      this.user.roles.splice(this.user.roles.indexOf(role), 1);
    }
  }

  public goBack() {}

  public save() {
    switch(this.formMode) {
      case FormMode.ADD: {
        this.userService.add(this.user).subscribe((result) => {
          this.router.stateService.go('user', null, {reload: true});
        });
      } break;

      case FormMode.UPDATE: {
        this.userService.update(this.user).subscribe((result: boolean) => {
          this.router.stateService.go('user', null, {reload: true});
        });
      }
    }
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/user/user-form.component.ts